import { useState, useEffect } from 'react';
import { useStore } from '@app/react-common/StoreContext';
import { IExtensionGroup } from '@app/pages/checkout-app/checkout-layout/main/components/extension-groups/models/extension-group.models';

const useExtensionGroups = () => {
  const [extensionGroups, setExtensionGroups] = useState<IExtensionGroup[]>([]);
  const { extensionGroups$ } = useStore();

  useEffect(() => {
    if (!extensionGroups$) {
      return;
    }

    const subscription = extensionGroups$.subscribe((groups: IExtensionGroup[] | null | undefined) => {
      // Handle null, undefined, or array
      if (Array.isArray(groups)) {
        setExtensionGroups(groups);
      } else {
        setExtensionGroups([]);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [extensionGroups$]);

  return {
    extensionGroups,
  };
};

export default useExtensionGroups;
